import { useCallback } from 'react';
import useReactRedux from "./useReactRedux";

/** @deprecated Please don't use this.  It has major problems.  See: https://applyboard.atlassian.net/browse/AWA-2580 */
function useReduxSelector(selector) {
  var mapStateToProps = useCallback(function (state) {
    return {
      data: selector(state)
    };
  }, [selector]);
  var _useReactRedux = useReactRedux(mapStateToProps),
    data = _useReactRedux.data;
  return data;
}
export default useReduxSelector;